export default __webpack_public_path__ + "static/media/img34.3fad4324.jpg";